import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/v2/store/selectors/dashboard';

export const countriesSelector = createSelector(dashboardSelector, (state) => state.countries);
